<div class="container-fluid row_banner pb-5">
  <app-header></app-header>
  <!-- Edditor  -->
  <div class="container">
    <div class="row text-center justify-content-center">
      <div class="col-lg-9 col-md-9 mb-4">
        <h1 class="titleH mtti tc">Sentence Checker</h1>
        <span class="description tc"
          >Make your sentences error-free with our sentence checker. Paste text
          to check sentences for structure, style and clarity.</span
        >
      </div>
    </div>
  </div>
  <!-- Editor -->
  <section class="mx-auto" style="max-width: 1320px; min-height: 530px;">
    <ng-template #landerContainer></ng-template>
    <!-- <div class="editor-card">
      <p
        class="text-left success-msg"
        *ngIf="got_recpatcha"
        [ngStyle]="{
          color: color,
          'background-color': '#f8d7da',
          padding: '2px'
        }"
      >
        <i class="fa fa-times-circle matr ml-1" aria-hidden="true"></i>
        {{ recaptcha_message }}
      </p>

      <div class="row-1">
        <div class="icon-bar">
          <div
            class="icon-bar-img"
            id="uploadFileS"
            value="Browse"
            onclick="document.getElementById('upload').click();"
          >
            <app-icons-free-tools [name]="'pcIcon'" />
            <input
              id="upload"
              data-name="upload-element"
              #fileInput
              accept=".txt,.doc,.docx,.pdf,.odt,.rtf,.tex"
              type="file"
              (change)="uploadFileSaveRedirect($event)"
            />
          </div>
          <div class="icon-bar-img" (click)="openDropboxChooser()">
            <app-icons-free-tools [name]="'dropboxIcon'" />
          </div>
          <div class="icon-bar-img" (click)="gDriveUpload()">
            <app-icons-free-tools [name]="'googleIcon'" />
          </div>
        </div>

        <div class="flex-1">
          <div style="position: relative">
            <quill-editor
              id="editor"
              [(ngModel)]="homeText"
              [modules]="editorModules"
              [theme]="'snow'"
              (onEditorCreated)="onEditorCreated($event)"
              class="typing-editor px-3"
              id="editor"
              #editor
              style="overflow-y: auto; overflow-x: hidden"
              (click)="onclickeditor($event)"
              [(ngModel)]="text"
              (onEditorCreated)="onHandleFormatting($event)"
              (onContentChanged)="count_Words_Character2()"
              placeholder=""
            >
            </quill-editor>

            <div *ngIf="showParagraph" class="editSectionDiv">
              <div *ngFor="let content of contentArray">
                <app-icons-free-tools [name]="'checktextIcon'" />
                <h3 class="editor-heading">{{ content.header }}</h3>
                <p class="paragraph">{{ content.paragraph }}</p>
                <div class="upload-buttons">
                  <button
                    [ngClass]="{
                      paste: button.text === 'Sample Text',
                      click: button.text === 'Paste Text',
                      'default-class': true
                    }"
                    *ngFor="let button of content.buttons"
                    class="textButtons"
                    (click)="executeAction(button.action)"
                  >
                    <app-icons-free-tools [name]="button.icon" />{{
                      button.text
                    }}
                  </button>
                </div>
              </div>
            </div>
            <span *ngIf="char_count !== 0">
              <app-icons-free-tools
                [name]="'deleteIcon'"
                (click)="deleteText()"
                class="icon-del"
              />
            </span>
            <div class="progress-loader-div">
              <div class="progress-loader" *ngIf="loaderAlert"></div>
            </div>
            <div class="bottom-icon ">
              <div class="word-char">
                <span class="wordCount">
                  Words: {{ char_count === 0 ? 0 : word_count }}
                </span>
                <span class="wordCount"
                  >Total Characters: {{ char_count }}</span
                >
              </div>

              <div *ngIf="captchaVisible" class="captcha-modal-overlay">
                <div class="captcha-modal">
                  <div
                    id="recaptcha-container"
                    class="recaptcha-container"
                    data-size="compact"
                    data-theme="light"
                  ></div>
                </div>
              </div>

              <div class="">
                <button
                  class="btn-Proofread buton"
                  (click)="handleButtonClick()"
                >
              
                  Check Sentence
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

  </section>
</div>
<div class="container mar80">
  <div class="row">
    <div class="col-lg-6 col-md-12 col-sm-12 intro-list-text">
      <div class="introduction mtcartab">
        <h2 class="title tcS">Introduction to GrammarIn Sentence Checker</h2>
        <p class="description tcS mt-3">
          The AI sentence checker by GrammarIn is designed to ensure the
          clarity, precision, and correctness of your writing. It goes beyond
          simple sentence corrections as it focuses on the finer details. It
          works on all sentence elements, including structure, flow, and style.
          The sentence corrector helps you maintain polished and articulate
          communication for professional, academic, or personal purposes. It
          instantly identifies areas where improvement is needed and offers
          suggestions to refine your writing and maintain consistency.
        </p>
      </div>
    </div>
    <div class="col-lg-6 col-md-12 col-sm-12 intro-list-col">
      <div class="intro-list">
        <img
          src="../../assets/images/sentence-checker/Introduction.svg"
          alt="Introduction to sentence Checker"
          width="392px"
          height="339px"
        />
      </div>
    </div>
  </div>
</div>

<div class="container mt-5">
  <app-premium />
</div>

<!-- <section class="">
  </section> -->
<section class="mar80">
  <div class="container">
    <h2 class="title tc">How to Use Our AI Sentence Checker</h2>
    <p class="description tc mt-3">
      The AI sentence checker is the easiest way to rectify mistakes in phrases
      and sentences. Here is a step-by-step guide for using it.
    </p>
    <div class="steps-container">
      <div
        class="step"
        *ngFor="let step of steps"
        [class.active]="hoveredIndex === step.id || activeStep === step.id"
        (mouseenter)="onHover(step.id)"
        (mouseleave)="onLeave()"
      >
        <app-icons-free-tools [name]="step.name" />
        <p>{{ step.text }}</p>
      </div>
    </div>
  </div>
</section>
<section class="mar80">
  <div class="container-fluid workingD">
    <!-- <div class="container"> -->
    <div class="row">
      <div class="col-lg-6">
        <div class="workingDContainer">
          <h2 class="title tcS">
            Working Behind GrammarIn's <br />
            Sentence Checker?
          </h2>
          <p class="description tcS">
            The algorithms behind
            <a
              href="https://www.grammarin.com/sentence-checker"
              style="color: white; text-decoration: underline"
              >GrammarIn sentence checker
            </a>
            combine advanced rule-based systems and machine learning models to
            ensure precise error detection. These algorithms scan each sentence
            by using pre-defined grammatical rules and linguistic patterns. They
            also leverage machine learning, which allows the tool to understand
            context and detect more subtle errors, such as misused words or
            awkward phrasing. By continuously learning from large datasets, our
            free sentence checker becomes more accurate over time, offering
            users clear recommendations to improve sentence structure, clarity,
            and overall writing quality.
          </p>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="imgDiv">
          <img
            src="../../assets/images/sentence-checker/working behind.png"
            alt="GrammarIn Sentence Checker Screenshot"
            class="image"
            height="395px"
            width="704px"
          />
          <!-- width: 704px;
                 height: 395px;
                 top: 2012px;
                 left: 736px;
                 gap: 0px;
                 opacity: 0px;
                   -->
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
</section>
<section class="mar80">
  <div class="container mt-5">
    <h2 class="title tc">
      Improve Sentence Structure and Style with <br />
      Sentence Checker Online
    </h2>
    <p class="description tc">
      The sentence checker online not only corrects errors but also enhances the
      structure and
      <a href="https://www.grammarin.com/handbook/style"> style </a> of your
      sentences. This sentence structure checker empowers users to elevate the
      quality of their writing by providing recommendations on sentence variety,
      clarity, and tone. It identifies common sentence structure mistakes and
      replaces them with concise alternatives that retain the original meaning.
      Our sentence check tool is a reliable assistant for creating
      well-structured and refined content.
    </p>
    <div class="features mt-5">
      <div class="row">
        <div class="feature col-md-3 col-sm-6" *ngFor="let feature of features">
          <app-icons-free-tools [name]="feature.name" />
          <p class="tit">{{ feature.title }}</p>
          <p class="des">{{ feature.description }}</p>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="mar80">
  <div class="container">
    <div class="row text-center justify-content-center">
      <div class="col-lg-9 col-md-9 mb-4">
        <h2 class="title">Key Features of Our Sentence Corrector</h2>
        <span class="description p-5"
          >The sentence corrector is specially curated to deal with all kinds of
          errors within the text. It offers a comprehensive suite of features
          designed to improve every aspect of your writing. Some prominent
          features of the sentence fixer are discussed below.
        </span>
      </div>
    </div>
    <div class="row mt-4">
      <div
        *ngFor="let item of contentCards; let i = index"
        class="col-lg-6"
        [ngClass]="{ martop: i % 2 !== 0 }"
      >
        <div class="common-tabM">
          <app-icons-free-tools [name]="item.icon" />
          <h3>{{ item.title }}</h3>
          <p [innerHTML]="item.description"></p>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-lg-4 martop" *ngFor="let tool of sentenceTools">
        <div class="common-tab">
          <app-icons-free-tools [name]="tool.icon" />
          <h3>{{ tool.title }}</h3>
          <p [innerHTML]="tool.description"></p>
        </div>
      </div>
    </div>
  </div>
</section>
<section>
  <div class="container">
    <div class="mostPopSec">
      <h2 class="title tc">
        Work with the Most Popular Sentence Checker on the Web
      </h2>
      <span class="description tc pdc d-flex"
        >The sentence checker has become a top choice for those seeking to
        improve their writing quality effortlessly. Its popularity is driven by
        its reliability and the value it adds to the writing process. You can
        also work with this versatile tool.
      </span>
      <div
        id="GramPlag_carousel"
        class="carousel slide d-inline-block mtcartab"
        data-ride="carousel"
      >
        <div class="carousel-inner">
          <div class="carousel-item active">
            <div class="carouselTab">
              <div class="row">
                <div class="col-lg-8 carouselTabText">
                  <h3>Improve Writing Clarity and Precision</h3>
                  <p>
                    The online sentence correction tool helps writers achieve
                    clarity and precision in their content by improving vague
                    expressions. It fine-tunes sentence structure to eliminate
                    confusion and ensures that each sentence conveys its
                    intended meaning.
                  </p>
                </div>
                <div class="col-lg-4">
                  <div class="carImg1"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="carouselTab">
              <div class="row">
                <div class="col-lg-8 carouselTabText">
                  <h3>Enhanced Readability for Target Audience</h3>
                  <p>
                    It is developed to improve the content readability and
                    adjust it for the intended audience, making your writing
                    more accessible and engaging. The AI sentence checker adapts
                    your text according to the audience, making it easier for
                    them to connect with your message.
                  </p>
                </div>
                <div class="col-lg-4">
                  <div class="carImg2"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="carouselTab">
              <div class="row">
                <div class="col-lg-8 carouselTabText">
                  <h3>Time-Saving in Content Creation</h3>
                  <p>
                    This tool reduces the time spent on revisions by automating
                    the correction of grammatical errors. Writers can focus on
                    creating content without worrying about minute details,
                    which is especially beneficial for those who need to meet
                    tight deadlines or handle large volumes of content.
                  </p>
                </div>
                <div class="col-lg-4">
                  <div class="carImg3"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="carouselTab">
              <div class="row">
                <div class="col-lg-8 carouselTabText">
                  <h3>Reduced Editing Effort</h3>
                  <p>
                    The AI sentence checker minimizes the effort required during
                    editing by catching common mistakes early. It highlights
                    areas for improvement as you write. That’s how it reduces
                    <a href="https://www.grammarin.com/blog/drawbacks-of-manual-proofreading/" target="_blank"> drawbacks of manual proofreading</a>.
                  </p>
                </div>
                <div class="col-lg-4">
                  <div class="carImg4"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ol class="carousel-indicators c_indi_banner">
          <li
            data-target="#GramPlag_carousel"
            data-slide-to="0"
            class="active"
          ></li>
          <li data-target="#GramPlag_carousel" data-slide-to="1"></li>
          <li data-target="#GramPlag_carousel" data-slide-to="2"></li>
          <li data-target="#GramPlag_carousel" data-slide-to="3"></li>
        </ol>
      </div>
    </div>
  </div>
</section>
<section>
  <div class="container secCon">
    <div class="row">
      <div class="col-lg-6">
        <div class="secConT">
          <h2 class="title tCSsec">
            Types of Sentences Our <br />
            Sentence Fixer Can Handle
          </h2>
          <span class="description tCSsec"
            >With our sentence corrector, you can
            <a
              href="https://www.grammarin.com/blog/how-to-write-better-sentences/"
              target="_blank"
              >write better sentences
            </a>
            for your writing endeavors. It can help with all types of
            statements, such as:
          </span>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="secTab">
          <div class="declTab">
            <h3>Declarative</h3>
            <p>
              The sentence fixer ensures that your declarative sentences are
              clear and accurate. This tool helps you confidently communicate
              facts and ideas and refine declarative sentences.
            </p>
          </div>
          <div class="exclTab mt30E martop">
            <h3>Exclamatory</h3>
            <p>
              It also ensures these sentences emphasize exclamatory sentences
              while remaining grammatically correct. It checks the proper
              placement of
              <a
                href="https://www.grammarin.com/what-does-exclamation-mark-mean"
              >
                exclamation marks
              </a>
              to enhance the impact of your emotions.
            </p>
          </div>
        </div>
        <div class="secTab mt-4">
          <div class="impTab mt30I">
            <h3>Imperative</h3>
            <p>
              The sentence structure checker polishes the structure of
              imperative sentences to make them concise and grammatically
              correct. It keeps your instructions clear and authoritative while
              maintaining the right tone, whether you're being polite or firm.
            </p>
          </div>
          <div class="intTab martop">
            <h3>Interrogatory</h3>
            <p>
              Interrogative sentences ask questions; the tool helps organize
              them correctly by focusing on word order and transparency. It
              ensures your questions are well-formed and easy to understand so
              they can be directly grammatically sound.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section>
  <div class="container-fluid dialect">
    <div class="container">
      <div class="row text-center justify-content-center">
        <div class="col-lg-9 col-md-9 mb-4">
          <h2 class="title text-white mt-5">
            A Sentence Checker Free for all English Dialects
          </h2>
          <span class="description text-white p-5"
            >Our English sentence checker is designed to accommodate all
            significant English dialects. It ensures that users from various
            regions can rely on it for accurate sentence corrections.
          </span>
        </div>
      </div>
      <div class="row dialectRow">
        <div class="col-md-3 martop" *ngFor="let dialect of dialects">
          <div class="dialectTab">
            <span class="bgw">
              <app-icons-free-tools [name]="dialect.icon" />
            </span>
            <h3>{{ dialect.name }}</h3>
            <p>{{ dialect.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="fqa mt-5 mb-5">
  <div class="container">
    <div class="row text-center justify-content-center">
      <div class="col-lg-9 col-md-9 mb-4 mt-5">
        <h2 class="title main-display">Frequently Asked Questions</h2>
      </div>
    </div>
    <div class="v-pills-tab-list row mt-3">
      <div id="row_faqs">
        <div
          class="nav flex-column nav-pills"
          id="v-pills-tab"
          role="tablist"
          aria-orientation="vertical"
        >
          <div
            class="container container-grid"
            style="width: min(100% - 40px, 768px)"
          >
            <div
              class="nav-link nav-pills"
              [ngClass]="{ active: activeTab === 'q1' }"
              (click)="toggleTab('q1')"
              id="v-pills-first-tab"
              aria-controls="q1"
              aria-expanded="false"
            >
              <h3 class="ms-3">
                <div class="d-flex nav-linkFAQ">
                  <div>
                    <span
                      class="card-header faqHeading"
                      [class.closed]="activeTab !== 'q1'"
                    >
                      How Accurate Is This Sentence Checker?</span
                    >
                  </div>
                  <div>
                    <app-icons-free-tools
                      name="plusIcon"
                      *ngIf="activeTab !== 'q1'"
                    />
                    <app-icons-free-tools
                      name="minusIcon"
                      *ngIf="activeTab === 'q1'"
                    />
                  </div>
                </div>
              </h3>
              <div
                aria-labelledby="q1"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q1' }"
                id="q1"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body faqPar ms-3 me-3">
                  Our sentence checker is highly accurate. It uses smart
                  algorithms and machine learning to find many types of
                  mistakes. It can spot simple and complex errors, like wrong
                  word use or sentence structure problems.
                </div>
              </div>
            </div>

            <div
              class="nav-link nav-pills"
              [ngClass]="{ active: activeTab === 'q2' }"
              (click)="toggleTab('q2')"
              id="v-pills-2nd-tab"
              aria-controls="q2"
              aria-expanded="false"
            >
              <h3 class="ms-3">
                <div class="d-flex nav-linkFAQ">
                  <div>
                    <span
                      class="card-header faqHeading"
                      [class.closed]="activeTab !== 'q2'"
                      >Do I Need to Register to Use This Sentence Check Tool?
                    </span>
                  </div>
                  <div>
                    <app-icons-free-tools
                      name="plusIcon"
                      *ngIf="activeTab !== 'q2'"
                    />
                    <app-icons-free-tools
                      name="minusIcon"
                      *ngIf="activeTab === 'q2'"
                    />
                  </div>
                </div>
              </h3>
              <div
                aria-labelledby="q2"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q2' }"
                id="q2"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body faqPar ms-3 me-3">
                  You do not need to register to use GrammarIn’s sentence check
                  facility. It is available for immediate use online without
                  requiring sign-up or registration.
                </div>
              </div>
            </div>

            <div
              class="nav-link nav-pills"
              [ngClass]="{ active: activeTab === 'q3' }"
              (click)="toggleTab('q3')"
              id="v-pills-3rd-tab"
              aria-controls="q3"
              aria-expanded="false"
            >
              <h3 class="ms-3">
                <div class="d-flex nav-linkFAQ">
                  <div>
                    <span
                      class="card-header faqHeading"
                      [class.closed]="activeTab !== 'q3'"
                      >Which Sentence Corrector Is Best for Academic
                      Writing?</span
                    >
                  </div>
                  <div>
                    <app-icons-free-tools
                      name="plusIcon"
                      *ngIf="activeTab !== 'q3'"
                    />
                    <app-icons-free-tools
                      name="minusIcon"
                      *ngIf="activeTab === 'q3'"
                    />
                  </div>
                </div>
              </h3>
              <div
                aria-labelledby="q3"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q3' }"
                id="q3"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body faqPar ms-3 me-3">
                  The sentence corrector by grammain.com is highly suitable for
                  academic writing. It ensures a formal tone and logical
                  sentence structure, making it an ideal choice for students,
                  researchers, and professionals.
                </div>
              </div>
            </div>

            <div
              class="nav-link nav-pills"
              [ngClass]="{ active: activeTab === 'q8' }"
              (click)="toggleTab('q8')"
              id="v-pills-3rd-tab"
              aria-controls="q8"
              aria-expanded="false"
            >
              <h3 class="ms-3">
                <div class="d-flex nav-linkFAQ">
                  <div>
                    <span
                      class="card-header faqHeading"
                      [class.closed]="activeTab !== 'q8'"
                      >Can I Fix My Sentence in Multiple English Dialects?
                    </span>
                  </div>
                  <div>
                    <app-icons-free-tools
                      name="plusIcon"
                      *ngIf="activeTab !== 'q8'"
                    />
                    <app-icons-free-tools
                      name="minusIcon"
                      *ngIf="activeTab === 'q8'"
                    />
                  </div>
                </div>
              </h3>
              <div
                aria-labelledby="q8"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q8' }"
                id="q8"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body faqPar ms-3 me-3">
                  Yes! Using our single platform, you can fix your sentences in
                  multiple English dialects easily.
                </div>
              </div>
            </div>

            <div
              class="nav-link nav-pills"
              [ngClass]="{ active: activeTab === 'q4' }"
              (click)="toggleTab('q4')"
              id="v-pills-4th-tab"
              aria-controls="q4"
              aria-expanded="false"
            >
              <h3 class="ms-3">
                <div class="d-flex nav-linkFAQ">
                  <div>
                    <span
                      class="card-header faqHeading"
                      [class.closed]="activeTab !== 'q4'"
                      >Is this Sentence Check Tool Used to Improve Sentence
                      Clarity?
                    </span>
                  </div>
                  <div>
                    <app-icons-free-tools
                      name="plusIcon"
                      *ngIf="activeTab !== 'q4'"
                    />
                    <app-icons-free-tools
                      name="minusIcon"
                      *ngIf="activeTab === 'q4'"
                    />
                  </div>
                </div>
              </h3>
              <div
                aria-labelledby="q4"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q4' }"
                id="q4"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body faqPar ms-3 me-3">
                  Yes! The online sentence checker is developed to improve
                  sentence clarity by identifying vague, awkward, or overly
                  complex phrasing.
                </div>
              </div>
            </div>

            <div
              class="nav-link nav-pills"
              [ngClass]="{ active: activeTab === 'q5' }"
              (click)="toggleTab('q5')"
              id="v-pills-5th-tab"
              aria-controls="q5"
              aria-expanded="false"
            >
              <h3 class="ms-3">
                <div class="d-flex nav-linkFAQ">
                  <div>
                    <span
                      class="card-header faqHeading"
                      [class.closed]="activeTab !== 'q5'"
                      >How Does Sentence Fixer Handle Complex Sentence
                      Structures?</span
                    >
                  </div>
                  <div>
                    <app-icons-free-tools
                      name="plusIcon"
                      *ngIf="activeTab !== 'q5'"
                    />
                    <app-icons-free-tools
                      name="minusIcon"
                      *ngIf="activeTab === 'q5'"
                    />
                  </div>
                </div>
              </h3>
              <div
                aria-labelledby="q5"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q5' }"
                id="q5"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body faqPar ms-3 me-3">
                  The sentence fixer easily handles complex sentence structures.
                  It identifies complex syntax and offers corrections that make
                  the sentence easier to understand.
                </div>
              </div>
            </div>

            <div
              class="nav-link nav-pills"
              [ngClass]="{ active: activeTab === 'q6' }"
              (click)="toggleTab('q6')"
              id="v-pills-6th-tab"
              aria-controls="q6"
              aria-expanded="false"
            >
              <h3 class="ms-3">
                <div class="d-flex nav-linkFAQ">
                  <div>
                    <span
                      class="card-header faqHeading"
                      [class.closed]="activeTab !== 'q6'"
                      >Is This Sentence Checker Free for All?</span
                    >
                  </div>
                  <div>
                    <app-icons-free-tools
                      name="plusIcon"
                      *ngIf="activeTab !== 'q6'"
                    />
                    <app-icons-free-tools
                      name="minusIcon"
                      *ngIf="activeTab === 'q6'"
                    />
                  </div>
                </div>
              </h3>
              <div
                aria-labelledby="q6"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q6' }"
                id="q6"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body faqPar ms-3 me-3">
                  Yes, the sentence checker is free for all users. You can
                  access it without any cost or subscription.
                </div>
              </div>
            </div>

            <div
              class="nav-link nav-pills"
              [ngClass]="{ active: activeTab === 'q7' }"
              (click)="toggleTab('q7')"
              id="v-pills-7th-tab"
              aria-controls="q7"
              aria-expanded="false"
            >
              <h3 class="ms-3">
                <div class="d-flex nav-linkFAQ">
                  <div>
                    <span
                      class="card-header faqHeading"
                      [class.closed]="activeTab !== 'q7'"
                      >Are Online Sentence Fixer Tools Legal for Sentence
                      Correction?
                    </span>
                  </div>
                  <div>
                    <app-icons-free-tools
                      name="plusIcon"
                      *ngIf="activeTab !== 'q7'"
                    />
                    <app-icons-free-tools
                      name="minusIcon"
                      *ngIf="activeTab === 'q7'"
                    />
                  </div>
                </div>
              </h3>
              <div
                aria-labelledby="q7"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q7' }"
                id="q7"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body faqPar ms-3 me-3">
                  Yes, the online sentence fixer is entirely legal for sentence
                  correction. It provides automated solutions based on publicly
                  available language guidelines. As long as the tool is used
                  ethically, it remains a legitimate resource for enhancing your
                  writing.
                </div>
              </div>
            </div>

            <div
              class="nav-link nav-pills"
              [ngClass]="{ active: activeTab === 'q9' }"
              (click)="toggleTab('q9')"
              id="v-pills-7th-tab"
              aria-controls="q9"
              aria-expanded="false"
            >
              <h3 class="ms-3">
                <div class="d-flex nav-linkFAQ">
                  <div>
                    <span
                      class="card-header faqHeading"
                      [class.closed]="activeTab !== 'q9'"
                      >Can I Check Multiple Sentences Using This Sentence
                      Checker Online?
                    </span>
                  </div>
                  <div>
                    <app-icons-free-tools
                      name="plusIcon"
                      *ngIf="activeTab !== 'q9'"
                    />
                    <app-icons-free-tools
                      name="minusIcon"
                      *ngIf="activeTab === 'q9'"
                    />
                  </div>
                </div>
              </h3>
              <div
                aria-labelledby="q9"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q9' }"
                id="q9"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body faqPar ms-3 me-3">
                  Yes! You can check multiple sentences at once using this free
                  sentence checker. The tool is designed to handle paragraphs
                  and larger blocks of text.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<app-feedback></app-feedback>
<div *ngIf="error" class="backdrop" id="error-22"></div>
<div *ngIf="error" class="content-div" id="error-22-cont">
  <div class="text-center" id="error-22-contInner">
    <!-- <img src="/assets/images/paraphrasing tool/alert.svg" alt="alert" /> -->
    <app-icons-free-tools name="errorIcon" />
    <div class="content-div-p">
      <p class="error mt-4" id="errorPT">
        {{ errorAlerts }}
      </p>
    </div>
    <button class="mt-5 butn-alert" (click)="closeErrorDiv()">Ok</button>
  </div>
</div>
<a
  (click)="scrollToTop()"
  *ngIf="shouldShowButton"
  id="scroll-to-top"
  data-tooltip="Go to top"
>
  <app-icons-free-tools name="goToTopIcon" />
</a>

<app-premium-modal-startup />

<app-footer></app-footer>
